module.exports = __webpack_public_path__ + "static/scale-model-of-cooper-young-historic-district-in-memphis-tennessee-ba123595ee6f0c86b702fd71d1f0a6f0.png";